/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionResponse } from '../models/ActionResponse';
import type { CreateInvitationRequest } from '../models/CreateInvitationRequest';
import type { CreateMissionResponse } from '../models/CreateMissionResponse';
import type { GetTokenResponse } from '../models/GetTokenResponse';
import type { Mission } from '../models/Mission';
import type { PingResponse } from '../models/PingResponse';
import type { ProviderDetails } from '../models/ProviderDetails';
import type { PurgeResponse } from '../models/PurgeResponse';
import type { ValueTupleOfStringAndMission } from '../models/ValueTupleOfStringAndMission';
import { request as __request } from '../core/request';

export class AdminService {

    /**
     * @returns PingResponse
     * @throws ApiError
     */
    public static async adminPing(): Promise<PingResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/ping`,
            headers: {
                "X-Requested-With": "XMLHttpRequest"
              }
        });
        return result.body;
    }

    /**
     * @returns ValueTupleOfStringAndMission
     * @throws ApiError
     */
    public static async adminGetMissions({
        onlyMine = true,
        withHistory = true,
        area = null
    }: {
        onlyMine?: boolean,
        withHistory?: boolean,
        area?: string
    }): Promise<Array<ValueTupleOfStringAndMission>> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/missions`,
            query: {
                'onlyMine': onlyMine,
                'withHistory': withHistory,
                'area': area
            },
        });
        return result.body;
    }

    /**
     * @returns ProviderDetails
     * @throws ApiError
     */
    public static async adminGetProviderDetails({
        environment,
        providerId,
        tags,
    }: {
            environment?: 'Prod' | 'Test' | 'SquadExpansionProd' | "SandboxSquirrel" | "SandboxCapybara" | "SandboxMousedeer" | "SandboxPlatypus" | "SandboxSloth" | "Spiir" | "SpiirTest" | "ProdNe" | "ProdWe" | "SpiirNe" | "SpiirWe" | "SpiirAws",
        providerId?: string | null,
        tags?: Array<string> | null,
    }): Promise<ProviderDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/providerDetails`,
            query: {
                'environment': environment,
                'providerId': providerId,
                'tags': tags,
            },
        });
        return result.body;
    }

    /**
     * @returns CreateMissionResponse
     * @throws ApiError
     */
    public static async adminCreate({
        mission,
    }: {
        mission: Mission,
    }): Promise<CreateMissionResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/create`,
            body: mission,
        });
        return result.body;
    }


    /**
     * @returns ActionResponse
     * @throws ApiError
     */
    public static async adminDeleteMission({
        missionId,
    }: {
        missionId: string | null,
    }): Promise<ActionResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/delete/${missionId}`,
        });
        return result.body;
    }

    /**
     * @returns PurgeResponse
     * @throws ApiError
     */
    public static async adminPurge(): Promise<PurgeResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/purge`,
        });
        return result.body;
    }

    /**
     * @returns ActionResponse
     * @throws ApiError
     */
    public static async adminCreateInvitation({
        request,
    }: {
        request: CreateInvitationRequest,
    }): Promise<ActionResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/invitation/create`,
            body: request,
        });
        return result.body;
    }

    /**
     * @returns GetTokenResponse
     * @throws ApiError
     */
    public static async adminGetToken(): Promise<GetTokenResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/token`,
        });
        return result.body;
    }

}